export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20movie%20theater%20ambience%20with%20warm%20deep%20red%20and%20rich%20golden%20accents%2C%20film%20reel%20textures%2C%20soft%20dramatic%20stage%20lighting%20with%20lens%20flare%2C%20dark%20elegant%20background%2C%20movie%20premiere%20luxury%20atmosphere%2C%20professional%20cinematography%2C%20high%20contrast%20composition&width=1600&height=900&seq=hero-main-7777-v2&orientation=landscape"
          alt="7777影院主视觉 - 电影级光影氛围"
          className="w-full h-full object-cover object-top"
          onError={(e) => {
            (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
          }}
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-500/20 text-accent-300 border border-accent-500/30 whitespace-nowrap mb-4">
              每日更新 · 海量资源 · 高清畅享
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-3">
              7777影院
              <br className="sm:hidden" />
              <span className="text-accent-400"> — 你的免费高清在线观影平台</span>
            </h1>

            <p className="text-base md:text-lg text-background-50/80 font-bold italic mb-4">
              随时随地，想看就看，精彩不间断
            </p>

            <p className="text-sm md:text-base text-background-50/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              7777影院汇聚海量电影、电视剧、综艺、动漫资源，覆盖院线大片、经典老片、热播剧集与独家专题。平台采用高速视频引擎，支持多线路切换与智能画质适配，无论电脑还是手机均可流畅观影。每日凌晨同步更新全网最新内容，确保你永远不错过任何一部好片。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-full bg-accent-500/20">
                  <i className="ri-movie-2-line text-accent-400 text-sm md:text-base"></i>
                </div>
                <div className="text-left">
                  <div className="text-accent-400 text-lg md:text-xl font-bold font-heading">10万+</div>
                  <div className="text-background-50/60 text-xs">影视资源</div>
                </div>
              </div>
              <div className="w-px h-8 bg-background-50/20 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-full bg-accent-500/20">
                  <i className="ri-speed-up-line text-accent-400 text-sm md:text-base"></i>
                </div>
                <div className="text-left">
                  <div className="text-accent-400 text-lg md:text-xl font-bold font-heading">极速</div>
                  <div className="text-background-50/60 text-xs">多线播放</div>
                </div>
              </div>
              <div className="w-px h-8 bg-background-50/20 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-full bg-accent-500/20">
                  <i className="ri-shield-check-line text-accent-400 text-sm md:text-base"></i>
                </div>
                <div className="text-left">
                  <div className="text-accent-400 text-lg md:text-xl font-bold font-heading">安全</div>
                  <div className="text-background-50/60 text-xs">无广告纯净</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg whitespace-nowrap cursor-pointer transition-colors text-sm"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-50/30 font-medium rounded-lg whitespace-nowrap cursor-pointer transition-colors text-sm"
              >
                了解更多
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Luxury%20home%20cinema%20setup%20with%20large%20screen%20displaying%20vibrant%20movie%20scene%2C%20warm%20ambient%20room%20lighting%2C%20red%20and%20gold%20accents%2C%20cozy%20velvet%20seating%2C%20professional%20home%20theater%20design%2C%20cinematic%20atmosphere%2C%20elegant%20interior&width=1200&height=900&seq=hero-visual-7777-v2&orientation=landscape"
                alt="7777影院观影体验 - 沉浸式家庭影院"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-500/80 backdrop-blur-sm cursor-pointer">
                  <i className="ri-play-fill text-background-50 text-xl md:text-2xl"></i>
                </div>
                <div className="flex-1">
                  <div className="text-background-50 text-xs md:text-sm font-medium">热门推荐正在播放</div>
                  <div className="w-full h-1 bg-background-50/20 rounded-full mt-1 overflow-hidden">
                    <div className="w-3/5 h-full bg-accent-500 rounded-full"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}